import axios from 'axios';
import React, {Component} from 'react';
import SVGInline from 'react-svg-inline';
import renderHTML from 'react-render-html';
import { bindActionCreators, compose } from "redux"
import { withProps, withStateHandlers } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps"
import {connect} from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Article from './main/article';
import Empty from './main/empty';
import NavBar from '../containers/parts/NavBar';

const WP_API_ENDPOINT = `${RT_API.root}wp/v2`;

class Map extends Component {
	
	constructor(props) {
	    super(props)
	    this.state = {
	      selectedMarker: false
	    }
	}
	
	componentWillUpdate() {
		window.scrollTo(0, 0);
	}

	posts(){
		let posts = this.props.posts
		//delete events.loading
		return Object.entries(posts)

	}
	
	isSingle() {
		return 1 === this.props.posts.length;
	}
	
	renderMarkers(posts) {
		if (posts.length) {
			return posts.map( post => {
				if (post.Marker) {
					//console.log(post);
					let imageUrl = null;
					let imageWidth = 0;
					let imageHeight = 0;
					if (post.featured_media !== 0 ){
						imageUrl = post.better_featured_image.source_url;
						imageWidth = post.better_featured_image.media_details.width; 
						imageHeight = post.better_featured_image.media_details.height;
					} 					
					let thisID = post.id;
					let latVal = parseFloat(post.Marker.geometry.coordinates[1]);
					let lngVal = parseFloat(post.Marker.geometry.coordinates[0]);
					const coords = {id: thisID, coords: { lat: latVal, lng: lngVal }, header: post.Marker.properties.description, content: post.content.rendered, image: imageUrl, imageW: imageWidth, imageH: imageHeight };
					//console.log(coords);
					return (coords);
				} else {
					return null;
				}
			});
		} else {
			const counter = [...Array(1)];
			return counter.map((val, i) => {
				let thisID = i;
				let latVal = parseFloat(39.950177 + (i / 100));
				let lngVal = parseFloat(-75.590137 + (i / 100));
				const coords = {id: thisID, coords: { lat: latVal, lng: lngVal }};
				//console.log(markerPos);
				return (coords);
			});
		}
		
	}

	
	render() {
		const marketState = withStateHandlers({
			isOpen: false
		}, {
			onMarkerClick: ({isOpen}) => () => ({isOpen: !isOpen})
		})


	        // This is the key!
		const MarkerPoint = compose(marketState)(props =>
	
			<Marker 
				key={props.marker.id}
			    position={{lat: props.marker.coords.lat, lng: props.marker.coords.lng}}
			    onClick={() => props.onMarkerClick()}
			    icon={props.icon}
			    >
	
				{props.isOpen &&
				   	<InfoWindow 
				   		position={{lat: props.marker.coords.lat, lng: props.marker.coords.lng}}
				        onCloseClick={() => props.onMarkerClick()}>
					    <div>
					    	{ props.marker.image !== '' &&
							    	<img className="alignright pop-image" src={ props.marker.image } width={props.marker.imageW} height={props.marker.imageH}/>
					    	}
					    	{ renderHTML( props.marker.header ) }
					    	<br />
					    	{ renderHTML( props.marker.content ) }
					    </div>
				    </InfoWindow>
				}
			</Marker>
		)
	
		const MapWithMarkers = compose(withScriptjs, withGoogleMap)(props =>
			<GoogleMap key={Math.floor(Math.random() * 100)}
			        defaultZoom={10}
					defaultCenter={{lat: 39.949948, lng: -75.680496}}>
					<MarkerPoint marker={{id: 0, coords: { lat: 39.950069, lng: -75.677830 }, header: "<img class=\"alignright pop-image\" src=\"/wp-content/uploads/sites/3/2018/10/MarshalltonVillageHeritageCenter-sm.jpg\" width=\"188\" height=\"250\"><div id=\"content\"><h1>Marshallton Village Heritage Center</h1></div>", content: "<p>The Marshallton Village Heritage Center was created to provide you with an interpretive experience of history all around you, a greater knowledge of the Battle of the Brandywine, and a connection to nearby natural, historic and scenic resources for you to explore. Marshallton Village walking tours are less than mile round-trip and can be enjoyed by visitors of all ages.</p>"}} icon={{url: "/wp-content/themes/chester-county-kiosk/images/mvhc-icon-orange.svg", scaledSize: { width: 46, height: 46 }}} />
				{
					props.markers.map((marker) => {
						if (marker){
							return (<MarkerPoint marker={marker} icon="" />)
						} else {
							return null;
						}
					})
				}
			</GoogleMap>
		)
	
		return (
			<div>
				<div className="map-wrapper menu">
					<MapWithMarkers
					    markers={this.renderMarkers(this.props.posts)}
					    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDlm1GMaQ12XiEttSQP7ay5AO9Y_um4LaQ&v=3.exp&libraries=geometry,drawing,places"
					    loadingElement={<div style={{ height: `100%` }}/>}
					    containerElement={<div id="map"/>}
					    mapElement={<div style={{ height: `100%`}} />}
					    />
				</div>
			</div>
		);
	}
}


function mapStateToProps({posts}) {
	return {posts};
}

export default connect(mapStateToProps)(Map)



// WEBPACK FOOTER //
// ./src/components/map.js